import { baseApi } from "./api";

// CAPMO import sync endpoints. These are server-side mutations (POST) that pull
// fresh data from CAPMO into our DB, so each one invalidates the RTK Query
// caches it actually changes - other screens then refetch instead of showing
// stale lists. The page reads loading/error straight off the mutation hooks and
// keeps the returned stats in local state (they are ephemeral, modal-only).
export const capmoSyncApi = baseApi.injectEndpoints({
	endpoints: (build) => ({
		syncAll: build.mutation({
			query: () => ({ url: "capmo-sync", method: "POST" }),
			transformResponse: (res) => ({
				stats: {
					projects: res?.projectStats?.projects || {},
					ticketCategories: res?.projectStats?.ticketCategories || {},
					projectMembers: res?.projectStats?.projectMembers || {},
					projectCompanies: res?.projectStats?.projectCompanies || {},
					users: res?.userStats?.users || {},
					companies: res?.userStats?.companies || {},
				},
				message: res?.message || "CAPMO_SYNC.SUCCESS",
			}),
			invalidatesTags: [
				"Project",
				"AdminProjects",
				"ProjectCompany",
				"ProjectMember",
				"TicketCategory",
				"AdminUsers",
			],
		}),
		syncProjects: build.mutation({
			query: () => ({ url: "capmo-sync/projects", method: "POST" }),
			transformResponse: (res) => ({
				stats: {
					projects: res?.projectStats?.projects || {},
					ticketCategories: res?.projectStats?.ticketCategories || {},
					projectMembers: res?.projectStats?.projectMembers || {},
					projectCompanies: res?.projectStats?.projectCompanies || {},
				},
				message: res?.message || "CAPMO_SYNC.PROJECT_SUCCESS",
			}),
			invalidatesTags: [
				"Project",
				"AdminProjects",
				"ProjectCompany",
				"ProjectMember",
				"TicketCategory",
			],
		}),
		syncUsers: build.mutation({
			query: () => ({ url: "capmo-sync/users", method: "POST" }),
			transformResponse: (res) => ({
				stats: {
					users: res?.userStats?.users || {},
					companies: res?.userStats?.companies || {},
				},
				message: res?.message || "CAPMO_SYNC.USER_SUCCESS",
			}),
			invalidatesTags: ["AdminUsers", "ProjectCompany"],
		}),
	}),
});

export const {
	useSyncAllMutation,
	useSyncProjectsMutation,
	useSyncUsersMutation,
} = capmoSyncApi;
